import React from "react";
import DetailsPageHeader from "../../../../common/DetailsPageHeader";
import { useAuth } from "../../../../hooks";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Box, CssBaseline } from "@mui/material";
import Sidebar from "../../../../common/Sidebar";
import GeneralAdminSidebar from "../../../../common/GeneralAdminSidebar";
import {
  mainLayoutStyles,
  images,
  showNotification,
  routes,
} from "../../../../constants";
import AddAlbumDataFieldsSection from "../../components/AddAlbumDataFieldsSection/AddAlbumDataFieldsSection";
import { useAlbumsContext } from "../../../../providers/OrganizationAdmin/AlbumProvider";
import { addAlbum, uploadAlbumImageToStorage } from "../../hooks/AlbumsHooks";
import AddAlbumFieldBottomCardSection from "../../components/AddAlbumFieldBottomCardSection/AddAlbumFieldBottomCardSection";
import ImagePreviewModal from "../../../../common/ImagePreviewModal";
import ConfirmationModal from "../../../../common/ConfirmationModal";

export default function AddAlbumContainer() {
  const { currentUser, currentLayoutAccess, organizationId } = useAuth();
  const navigate = useNavigate();
  const { handleGetAllAlbums, allAlbums } = useAlbumsContext();
  const [imagePreviewModal, setImagePreviewModal] = useState(false);
  const [uploadImage, setUploadImage] = useState(null);
  const [editEnabled, setEditEnabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);

  const [addAlbumsField, setAddAlbumsField] = useState({
    photoUrl: "",
    title: "",
    createdBy: currentUser.userName,
    description: "",
    privacy: "",
    id: currentUser.id,
    createdAt: new Date(),
  });
  console.log("addAlbumsField", addAlbumsField);

  const handleCancelModalOpen = () => {
    setCancelModal(true);
  };
  const handleCancelModalClose = () => {
    setCancelModal(false);
  };

  const handleCancel = () => {
    try {
      setLoading(true);
      handleCancelModalClose();
      navigate(routes.albumsInOrg);
      setLoading(false);
    } catch (error) {
      console.log("handleCancel error: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleImagePreviewModalOpen = () => {
    setImagePreviewModal(true);
  };

  const handleImagePreviewModalClose = () => {
    setImagePreviewModal(false);
  };
  const handleSubmit = async () => {
    setLoading(true);
    try {
      // Prepare new album object
      const newAddAlbumData = {
        title: addAlbumsField.title,
        description: addAlbumsField.description,
        privacy: addAlbumsField.privacy,
        createdAt: new Date(),
        quicktales: [],
        // user: `${currentUser?.firstName} {${currentUser?.lastName}}`,
        createdBy: `${currentUser?.firstName + " " + currentUser?.lastName}`,
        organization: organizationId
          ? organizationId
          : currentUser?.organization,
        // createdBy: currentUser?.id,
        // id: currentUser.id,
        //implement these feilds, when adding album from admin
        // isCreatedBy:"admin",
        // organization: "org id"
      };
      // if (currentUser?.organization) {
      //   newAddAlbumData.organization = currentUser?.organization;
      // }
      // if (organizationId != null) {
      //   newAddAlbumData.organization = organizationId;
      // }
      if (uploadImage != null) {
        let photoUrl = await uploadAlbumImageToStorage(uploadImage?.raw);
        newAddAlbumData.photoUrl = photoUrl;
        newAddAlbumData.originalPhotoName = uploadImage?.raw?.name;
      }
      // console.log("newAddAlbumData", newAddAlbumData);
      // Add the new album to the backend
      let responseTemp = await addAlbum(newAddAlbumData);

      // Refresh the list of albums
      await handleGetAllAlbums();
      setLoading(false);
      // Clear input fields after submission
      setAddAlbumsField({
        photoUrl: "",
        title: "",
        createBy: currentUser.userName,
        // id: currentUser.id,
        description: "",
        privacy: "",
        createdAt: new Date(),
      });
      setUploadImage(null);
      showNotification("Album added successfully.");
      navigate(-1);
      // Toast("success", "Album added successfully.");
    } catch (error) {
      console.error("Error submitting album data:", error);
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <DetailsPageHeader
        mainTitle={`Add Album`}
        bgColor="#fff"
        buttonText={"Continue Editing"}
        editEnabled={editEnabled}
        setEditEnabled={setEditEnabled}
        onCancelClick={() => handleCancelModalOpen()}
        cancelButton={true}
        submitButtonText={"Add Album"}
        handleSave={() => handleSubmit()}
        loading={loading}
      />
      <Sidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"} style={subContainerStyles}>
          {/*Data card/container section*/}
          <AddAlbumDataFieldsSection
            addAlbumsField={addAlbumsField}
            setAddAlbumsField={setAddAlbumsField}
            allAlbums={allAlbums}
            handleImagePreviewModalOpen={handleImagePreviewModalOpen}
            editEnabled={editEnabled}
            setEditEnabled={setEditEnabled}
            uploadImage={uploadImage}
            setUploadImage={setUploadImage}
          />
          <ImagePreviewModal
            modalOpen={imagePreviewModal}
            handleClose={handleImagePreviewModalClose}
            image={
              uploadImage != null && uploadImage.preview
                ? uploadImage.preview
                : images.tableDummyImage
            }
          />
        </Grid>
      </Grid>
      <ConfirmationModal
        open={cancelModal}
        onClose={handleCancelModalClose}
        onConfirm={handleCancel}
        title={"Are you sure to Cancel adding new album?"}
      />
    </Box>
  );
}

const subContainerStyles = {
  paddingLeft: 30,
  paddingRight: 30,
  marginTop: 50,
};
